/**
 * subscription-toggle.js
 * Toggles a single cart item between one-time and subscription
 * Supports Foxecom/Dawn-style cart drawers
 */

async function toggleSubscription(line, variantId, sellingPlanId, subscribe = true) {
  try {
    // Get current cart to preserve quantity
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const item = cart.items.find((_, idx) => idx + 1 === line);
    if (!item) return console.warn('Item not found in cart');

    const currentQty = item.quantity;

    // Remove current line
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: 0 }),
    });

    // Re-add same item with or without selling plan
    const payload = {
      id: variantId,
      quantity: currentQty,
      ...(subscribe ? { selling_plan: sellingPlanId } : {}),
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.json();
      console.warn('Shopify error:', err);
    }

    // Trigger your theme’s built-in cart refresh
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true },
    }));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  } catch (err) {
    console.error('Subscription toggle failed:', err);
  }
}

// Listen for checkbox toggle
document.addEventListener('change', async (e) => {
  const box = e.target.closest('.subscription-checkbox');
  if (!box) return;

  box.disabled = true;

  const line = Number(box.dataset.line);
  const variantId = Number(box.dataset.variantId);
  const sellingPlanId = Number(box.dataset.sellingPlanId);
  const isChecked = box.checked;

  await toggleSubscription(line, variantId, sellingPlanId, isChecked);

  box.disabled = false;
});
